<!-- Header -->
<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="onDismiss()">
        <app-ds-icon name="close-x" size="icon-size-2" color="var(--color-core-neutral-7)"></app-ds-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="true">
  <h1 class="ds-heading-1">{{ 'TRANSACTIONS.filter.modal.title' | translate }}</h1>
  <div class="transactions-chips">
    <p class="ds-ui-2">{{ 'TRANSACTIONS.filter.modal.range.title' | translate }}</p>
    <div>
      @for (filter of dateRangeFilters; track filter) {
        <app-ds-chip [active]="filter === rangeFilter" [value]="filter" (check)="onRangeSelect($event)">
          {{ 'TRANSACTIONS.filter.modal.range.' + filter | translate }}
        </app-ds-chip>
      }
    </div>
  </div>
  @if (rangeFilter === transactionsRangeFilters.CUSTOM_RANGE) {
    <form [formGroup]="form">
      <div class="transactions-custom">
        <div class="ds-form-row">
          <label class="ds-label">{{ 'TRANSACTIONS.filter.modal.range.from' | translate }}</label>
          <div class="transactions-input">
            <input readonly type="text" class="ds-input" (click)="onInputClick(true)" formControlName="from" />
            <app-ds-icon name="calendar-days" size="icon-size-2" [color]="'var(--color-core-neutral-7)'"></app-ds-icon>
          </div>
        </div>

        <div class="ds-form-row">
          <label class="ds-label">{{ 'TRANSACTIONS.filter.modal.range.to' | translate }}</label>
          <div class="transactions-input">
            <input readonly type="text" class="ds-input" (click)="onInputClick()" formControlName="to" />
            <app-ds-icon name="calendar-days" size="icon-size-2" [color]="'var(--color-core-neutral-7)'"></app-ds-icon>
          </div>
        </div>
      </div>
    </form>
  }

  <ion-modal #fromModal is-open="false" focusTrap="false" class="transactions-calendar-modal">
    <ng-template>
      <ion-datetime
        mode="md"
        #fromDateRange
        presentation="date"
        class="transactions-calendar"
        [value]="customRange.from"
        [showDefaultButtons]="true"
        [locale]="language"
        [max]="fromMax"
        (ionChange)="onValueChange($event, true)"
      >
        <div slot="buttons" class="transactions-calendar-buttons">
          <app-ds-button variant="outline" size="small" width="auto" (clicked)="fromDateRange.cancel(true)">
            {{ 'TRANSACTIONS.filter.modal.range.cancel' | translate }}
          </app-ds-button>
          <app-ds-button variant="primary" size="small" width="auto" (clicked)="fromDateRange.confirm(true)">
            {{ 'TRANSACTIONS.filter.modal.range.fromDate' | translate }}
          </app-ds-button>
        </div>
      </ion-datetime>
    </ng-template>
  </ion-modal>

  <ion-modal #toModal is-open="false" focusTrap="false" class="transactions-calendar-modal">
    <ng-template>
      <ion-datetime
        mode="md"
        #toDateRange
        presentation="date"
        class="transactions-calendar"
        [showDefaultButtons]="true"
        [value]="customRange.to"
        [locale]="language"
        [min]="toMin"
        [max]="toMax"
        (ionChange)="onValueChange($event, false)"
      >
        <div slot="buttons" class="transactions-calendar-buttons">
          <app-ds-button variant="outline" size="small" width="auto" (clicked)="toDateRange.cancel(true)">
            {{ 'TRANSACTIONS.filter.modal.range.cancel' | translate }}
          </app-ds-button>
          <app-ds-button variant="primary" size="small" width="auto" (clicked)="toDateRange.confirm(true)">
            {{ 'TRANSACTIONS.filter.modal.range.toDate' | translate }}
          </app-ds-button>
        </div>
      </ion-datetime>
    </ng-template>
  </ion-modal>

  <div class="transactions-chips transactions-type-chips">
    <p class="ds-ui-2">{{ 'TRANSACTIONS.filter.modal.type.title' | translate }}</p>
    <div>
      @for (filter of typeFilters; track filter) {
        <app-ds-chip
          [active]="(filter === 'all' && selectedTypeFilters.length === 0) || selectedTypeFilters.includes(filter)"
          [value]="filter"
          [enableUncheck]="true"
          (check)="onTypeSelect($event)"
        >
          {{ 'TRANSACTIONS.filter.modal.type.' + filter | translate }}
        </app-ds-chip>
      }
    </div>
  </div>

  <div class="transactions-actions">
    <app-ds-button variant="primary" width="full" (clicked)="onFiltersApply()">
      {{ 'TRANSACTIONS.filter.modal.actions.applyBtn' | translate }}
    </app-ds-button>
    <app-ds-button icon="x" variant="outline" width="full" (clicked)="onFilterClear()">
      {{ 'TRANSACTIONS.filter.modal.actions.clearBtn' | translate }}
    </app-ds-button>
  </div>
</ion-content>
